import { post, get, put, deletes, toJson, isEmpty } from "@/plugins/http.js";


import { config } from '@/api/config/default.js'


const apiMall = config.apiMall;
const javaApi = config.javaApi;
const appName = config.javaAappNamepi;
const isOverseas = config.isOverseas;
const unit = config.unit;

export const miniProgramUrl = config.javaApi + "scan";


/**
 *
 * @param  {[type]} params [description]
 * @return {[type]}        [description]
 */

//一级分类
export function rootCtegoryList() {
  return post(javaApi + "wxappProdtp/topProdtpListInfo", {});
}

//二级三级分类
export function childGoodsCatetoryList(id) {
  return get(javaApi + "wxappProdtp/childrenProdtpListInfo/" + id, {});
}

//全部分类
export function allChildrenProdtpListInfo() {
  return get(javaApi + "wxappProdtp/allChildrenProdtpListInfo", {});
}


//分类商品查询
export function getCatetoryItems(parameter) {
  return request({
    url: javaApi + "wxappProdtp/prodtpShareGoods",
    method: "post",
    data: parameter,
  });
}

//查询商品列表
export function getGoodsList(parameter) {
  return post(javaApi + "wxappProduct/searchShareGoods", parameter);
}

//首页轮播
// const getAdList = (params) => wxRequest(params, apiMall + 'api/wxapp/index.php?do=adverts');
// const getAdList = (params) => wxRequest(params, javaApi + 'wxappShop/banners');
export function getAdList() {
  return post(javaApi + "wxappHomeTopBanner/list", {});
}

//首页商品列表展示
// const getProductList = (params) => wxRequest(params, apiMall + 'api/wxapp/index.php?do=infoList');

//首页橱窗
export function getShowcase() {
  return post(javaApi + "wxappShowcase/covers/2", {});
}

//首页橱窗
export function getShowcaseList(parameter) {
  return request({
    url: javaApi + "wxappShowcase/itemPages",
    method: "post",
    data: parameter,
  });
}
//登录得到code抛给后台
export function getOpenId(parameter) {
  return post(javaApi + "wxappMember/login", parameter);
}

//登录
export function getLogin(parameter) {
	//pc商城注册
	parameter.registerType =4;
  return post(javaApi + "apiMember/login", parameter);
}

//注册
export function memberRegister(parameter) {
  return post(javaApi + "wxappMember/register", parameter);
}

//用户信息
export function getMemberInfo() {
  return get(javaApi + "wxappMember/member");
}

//得到短信验证码
// export function getTelCode= (params) => wxRequest(params, apiMall + 'api/wxapp/user.php?do=telcode');
export function getTelCode(parameter) {
  return request({
    url: javaApi + "publicUtils/telcode",
    method: "post",
    data: parameter,
  });
}
//商品详情接口
export function getPdDetail(parameter) {
  return get(javaApi + "wxappProduct/goods_info", parameter);
}
//商品规格接口
// export function getPdSpeDetail= (params) => wxRequest(params, apiMall + 'api/wxapp/prods.php?do=productinfo');
export function getPdSpeDetail(parameter) {
  return get(javaApi + "wxappProduct/product_info", parameter);
}
//添加购物车
export function addCarts(parameter) {
  return post(javaApi + "wxappCart/addCart", parameter);
}
//查看购物车
// export function getCarts= (params) => wxRequest(params, apiMall + 'api/wxapp/order.php?do=getcarts');
export function getCarts(parameter) {
  return get(javaApi + "wxappCart/getCarts", parameter);
}
//删除购物车
// export function delCarts = (params) => wxRequest(params, apiMall + 'api/wxapp/order.php?do=delcarts');
export function delCarts(parameter) {
  return post(javaApi + "wxappCart/delCarts", parameter);
}
//修改购物车
export function addCartsNum(parameter) {
  return post(javaApi + "wxappCart/editCartNum", parameter);
}
//编辑收货地址
export function editAddress(parameter) {
  return post(javaApi + "wxappOrders/modifyLinkAddress",parameter);
}
//新增收货地址
export function addAddress(parameter) {
  return post( javaApi + "wxappOrders/addLinkAddress",parameter);
}
//获取收货人地址
// export function getAddress = (params) => wxRequest(params, apiMall + 'api/wxapp/order.php?do=getaddsform');
export function getAddress() {
  return get(javaApi + "wxappOrders/getLinkAddress", {});
}

//根据id获取地址
export function getAddressById(id) {
  return get(javaApi + "wxappOrders/getLinkAddress/"+id);
}
//删除地址
// export function delAddress = (params) => wxRequest(params, apiMall + 'api/wxapp/order.php?do=adds_del');
export function delAddress(parameter) {
  return request({
    url: javaApi + "wxappOrders/deleteLinkAddress/",
    method: "post",
    data: parameter,
  });
}
//下单购买支付
// export function addOrderBuy=(params) => wxRequest(params, apiMall + 'api/wxapp/order.php?do=addorder_buy');
export function addOrderBuy(parameter) {
  return request({
    url: javaApi + "wxappOrders/phpCreateAndBuy",
    method: "post",
    data: parameter,
  });
}
export function pendingOrderBuy(parameter) {
  return request({
    url: javaApi + "wxappOrders/pending_order",
    method: "post",
    data: parameter,
  });
}
//订单界面支付
// export function wxBuy = (params) => wxRequest(params, apiMall + 'api/wxapp/order.php?do=wx_buy');

//取得创建订单前的信息
export function preCreateOrderInfo(parameter) {
  return post(javaApi + "wxappOrders/pre_create_order_info", parameter);
}
//提交订单
export function createOrderAndBackWaitePayInfo(parameter) {
  return post(javaApi + "wxappOrders/pending_order", parameter);
}

//获取订单的状态
export function getOrderTagByOrdersId(orderId) {
  return get(javaApi + "wxappOrders/getOrderTagByOrdersId/"+orderId);
}
//得到订单列表
// export function getOrderList = (params) => wxRequest(params, apiMall + 'api/wxapp/order.php?do=get_order');
export function getOrderList(parameter) {
  return post(javaApi + "wxappOrders/getOrderInfoPages",parameter);
}
//获取单个订单详情
export function getOrderInfo(ordersId) {
  return get(javaApi + "wxappOrders/getOrderInfoByOrdersId/"+ordersId);
}

//确认收货
export function confirmReceive(ordersId) {
  return post(javaApi + "wxappOrders/confirm_receive/"+ordersId);
}
//获取单个订单付款码
export function getPayQrCode(ordersId,payWay) {
  return get(javaApi + "wxappOrders/getPayQrCode/"+ordersId+"/"+payWay);
}
//获取物流信息
export function getTrackingInfo(parameter) {
  return request({
    url: javaApi + "wxappOrders/getTrackingByOrdersId/",
    method: "post",
    data: parameter,
  });
}
//获取申请售后的数据
export function getAfterSale(afterSalesId) {
  return get(javaApi + "wxappAfterSales/getAfterSalesById/"+afterSalesId);
}
//申请售后
export function addAfterSale(parameter) {
  return post(javaApi + "wxappAfterSales/add",parameter);
}
//重新申请售后
export function reApplyAfterSale(parameter) {
  return request({
    url: javaApi + "wxappAfterSales/reApply",
    method: "post",
    data: parameter,
  });
}
//售后详情
export function getAfterSaleDetail(parameter) {
  return request({
    url: javaApi + "wxappAfterSales/getAfterSalesById/",
    method: "post",
    data: parameter,
  });
}
//售后详情页
export function caseInfo(parameter) {
  return request({
    url: javaApi + "api/wxapp/order.php?do=caseinfo",
    method: "post",
    data: parameter,
  });
}
//取消订单
export function cancelOrder(ordersId) {
  return post(javaApi + "wxappOrders/cancelOrder",{ordersId:ordersId});
}
//订单页支付
// export function orderBuy=(params) => wxRequest(params, apiMall + 'api/wxapp/order.php?do=wx_buy');
export function orderBuy(parameter) {
  return request({
    url: javaApi + "wxappOrders/phpOrderBuy",
    method: "post",
    data: parameter,
  });
}
//汇率接口
// export function getCurrency=(params) => wxRequest(params, apiMall + 'api/wxapp/index.php?do=get_currency');
export function getCurrency(parameter) {
  return request({
    url: javaApi + "wxappOrders/channelExchangeRate",
    method: "post",
    data: parameter,
  });
}
//新闻列表
export function getNewsList(parameter) {
  return request({
    url: javaApi + "wxappArticle/titles",
    method: "post",
    data: parameter,
  });
}
//新闻详情
export function getNewsDetail(parameter) {
  return request({
    url: javaApi + "wxappArticle/detials/",
    method: "post",
    data: parameter,
  });
}
//活动接口
export function getActivity(parameter) {
  return request({
    url: javaApi + "wxappCommend/",
    method: "post",
    data: parameter,
  });
}
//热门频道首页图标列表
export function getHotChannels(parameter) {
  return request({
    url: javaApi + "wxappCommend/hot_channels",
    method: "post",
    data: parameter,
  });
}
//热门频道商品列表
export function getHotList(parameter) {
  return request({
    url: javaApi + "wxappCommend/share_goods",
    method: "post",
    data: parameter,
  });
}
//热门品牌
export function getBrands() {
  return post(javaApi + "wxappCommend/brands", {});
}

//热门品牌商品列表
export function getBrandsList(parameter) {
  return request({
    url: javaApi + "wxappProduct/brand_share_goods/",
    method: "post",
    data: parameter,
  });
}

//得到二维码
export function getQRCode(parameter) {
  return request({
    url: javaApi + "wxAppWeiXinApi/createQRcode",
    method: "post",
    data: parameter,
  });
}

//获得当天时段列表
export function getTimeList(parameter) {
  return request({
    url: javaApi + "wxappoffprice/time_slots",
    method: "post",
    data: parameter,
  });
}

//获得当天时段列表
export function getTimeGoodsList(parameter) {
  return request({
    url: javaApi + "wxappoffprice/time_slot_off_price_share_goods",
    method: "post",
    data: parameter,
  });
}

//特价活动列表
export function getOffPrice(parameter) {
  return request({
    url: javaApi + "wxappoffprice/off_prices",
    method: "post",
    data: parameter,
  });
}

//特价活动组合商品列表
export function getOffPriceGoods(parameter) {
  return request({
    url: javaApi + "wxappoffprice/off_price_share_goods",
    method: "post",
    data: parameter,
  });
}

//团购商品列表
export function getGroupGoods(parameter) {
  return request({
    url: javaApi + "WxAppGroupBuying/group_buying_sharegoods",
    method: "post",
    data: parameter,
  });
}

//获取我的参团信息
export function getMyGroup(parameter) {
  return request({
    url: javaApi + "WxAppGroupBuying/group_buyings",
    method: "post",
    data: parameter,
  });
}

//领券中心优惠券列表
export function getCouponCenter(parameter) {
  return request({
    url: javaApi + "wxappCoupon/pages",
    method: "post",
    data: parameter,
  });
}

//我的优惠券列表
export function getMyCoupon(parameter) {
  return request({
    url: javaApi + "wxappCoupon/my/",
    method: "post",
    data: parameter,
  });
}
//领取优惠券
export function getTakeCoupons(parameter) {
  return request({
    url: javaApi + "wxappCoupon/take",
    method: "post",
    data: parameter,
  });
}
//下单时可用优惠券
export function getAvailableCoupons(parameter) {
  return request({
    url: javaApi + "wxappCoupon/available",
    method: "post",
    data: parameter,
  });
}

//获取运费
export function getTransPrice(parameter) {
  return request({
    url: javaApi + "wxappOrders/trans_price",
    method: "post",
    data: parameter,
  });
}

//获取分销账户信息
export function getResellerBalance(parameter) {
  return request({
    url: javaApi + "wxappreseller/balance",
    method: "post",
    data: parameter,
  });
}

//获取分销订单
export function getResellerOrders(parameter) {
  return request({
    url: javaApi + "wxappreseller/orders",
    method: "post",
    data: parameter,
  });
}

//提现申请
export function postResellerWithdraw(parameter) {
  return request({
    url: javaApi + "wxappreseller/withdraw",
    method: "post",
    data: parameter,
  });
}

//获取提现明细
export function getResellerWithdraws(parameter) {
  return request({
    url: javaApi + "wxappreseller/withdraws",
    method: "post",
    data: parameter,
  });
}

//申请成为分销商
export function applyResellerMerchant(parameter) {
  return request({
    url: javaApi + "wxappreseller/merchant",
    method: "post",
    data: parameter,
  });
}

//用户注册协议
export function getRegisterProtocol(parameter) {
  return get(javaApi + "wxAppSystemConfig/register_protocol");
}

//隐私政策
export function getPrivacyPolicy(parameter) {
  return get(javaApi + "wxappArticle/detialsByTitle?title=隐私政策");
}

//获取商城咨询
export function getActicleByTitle(title) {
  return get(javaApi + "wxappArticle/detialsByTitle?title="+title);
}

//系统配置
export function getSystemConfig(parameter) {
  return get(javaApi + "wxAppSystemConfig/system_config", parameter);
}

/**
 * @description 我的订单提示数量
 */
export function getOrderTipQty(parameter) {
  return request({
    url: javaApi + "wxappOrders/order_tip_qty",
    method: "post",
    data: parameter,
  });
}

//易生快捷支付签约
export function unionPaymentSign(parameter) {
  return post(javaApi + "wxappOrders/unionPaymentSign", parameter);
}

//易生快捷支付签约结果
export function unionPaymentSignNotify(parameter) {
  return post(javaApi + "wxappOrders/unionPaymentSignNotify", parameter);
}

//易生快捷支付发送短信验证码
export function unionPaymentSmsSend(accountNumber,amount) {
  return get(javaApi + `wxappOrders/unionPaymentSmsSend/${accountNumber}/${amount}`);
}

//易生快捷支付
export function unionPaymentPayWithSms(parameter) {
  return post(javaApi + "wxappOrders/unionPaymentPayWithSms", parameter);
}
